import React from 'react';
import { Box, Typography } from '@mui/material';

/** Display the legend for the map */
const Legend = ({ data }) => {
  return (
    <Box sx={{ 
      position: 'absolute', 
      bottom: 10, 
      left: 10, 
      zIndex: 1000, 
      backgroundColor: '#fff', 
      padding: 2, 
      borderRadius: 2, 
      boxShadow: 3 
    }}>
      <Typography variant="h6" fontWeight="bold">Legend</Typography>
      {Object.keys(data).map((category, index) => (
        <Box key={index} sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
          {/* Use the marker icon for the legend */}
          <Box
            component="img"
            src={data[category].imageSrc} // Use the marker icon URL
            alt={`${category} icon`}
            sx={{
              width: 20,
              height: 20,
              marginRight: 1,
            }}
          />
          <Typography variant="body2">{category}</Typography>
        </Box>
      ))}
    </Box>
  );
};

export default Legend;